<template>
  <div>
    <el-dialog title="极简光方案弱电箱购买指南" :visible.sync="dialogTwoVisible" :show-close="false">
      <div class="share-text-row">
        1. 项目极简光交换机部署在弱电箱场景，建议采购下面指定弱电箱。采用指定弱电箱（经过我司测试），壳温只会比室温环境高10℃，同时有安装拆卸的零部件设计；
        注意：市面上开孔率不达标，会造成设备壳温高。
      </div>

      <div class="share-text-row">
        2. 弱电箱采购采用和第三方供应商合作的方式，提供以下款型：
      </div>

      <table class="table-share-wrap">
        <tr>
          <th>产品型号</th>
          <th>规则</th>
          <th>尺寸</th>
          <th>价格（含税，不含税可减13%）</th>
        </tr>
        <tr>
          <td style="color: #606266">RG-TransBOX-EMB</td>
          <td>内嵌式弱电箱（包含基座+门板），含插排，不含熔纤盒（可加购）</td>
          <td>400*300*120</td>
          <td>122</td>
        </tr>
        <tr>
          <td style="color: #606266">RG-TransBOX-EMB-Door</td>
          <td>内嵌式弱电箱门板（仅包含门板）</td>
          <td>400*300、350*300、300*250、400*300、350*300、300*250</td>
          <td>50</td>
        </tr>
        <tr>
          <td style="color: #606266">RG-TransBOX-WALL</td>
          <td>壁挂式弱电箱（包含基座+门板），含插排，不含熔纤盒（可加购）</td>
          <td>400*400*80</td>
          <td>128</td>
        </tr>
      </table>
      <div class="share-text-row">
        3. 下单渠道：
        联系人王经理：15355930777
        <br>
        &nbsp;&nbsp;&nbsp;&nbsp;阿里巴巴采购链接：https://zhilingdq.1688.com/（注意：开票需要备注，默认不开票。含税不含税价格有差）
      </div>

      <div class="share-text-row">
        4. 下单采购请采用现金全额转账，付款后14天到货。
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTwoVisible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WeakCurrentBoxScene',
  data () {
    return {
      dialogTwoVisible: false
    };
  },
  components: {},
  props: {},
  methods: {
    openWeakCurrentBoxScene () {
      this.dialogTwoVisible = true;
    }
  }
};
</script>

<style scoped>
  /*二次弹框*/
  .share-text-row {
    padding-bottom: 10px;
    text-align: left;
  }

  .table-share-wrap, .table-share-wrap th, .table-share-wrap td{
    margin-bottom: 10px;
    border: 1px solid #eee;
  }

  .table-share-wrap{
    border-collapse: collapse;
  }

</style>
